import { FieldSectionSubType } from 'api/field-sections/types';
const NUMBER_OF_FIELD_IN_SINGLE_DECIMAL = 25;
export const decimalToBase3Array = (decimal, expectedLength = NUMBER_OF_FIELD_IN_SINGLE_DECIMAL)=>Array.from(decimal.toString(3).padStart(expectedLength, '0'), (x)=>Number(x)).reverse();
export const decimalsToBase3Array = (decimals)=>decimals.reduce((result, decimal)=>result.concat(decimalToBase3Array(decimal)), []);
export const fieldAccessMetaToBase3 = (fieldAccessMeta)=>{
    return Object.entries(fieldAccessMeta).reduce((base3Map, [objectType, decimals])=>{
        base3Map[objectType] = decimalsToBase3Array(decimals);
        return base3Map;
    }, {});
};
export const hasReadAccessForField = (field, accessMeta)=>{
    var _accessMeta_objectType;
    if (accessMeta == null) {
        return false;
    }
    const { objectType } = field;
    if (field.fieldIndex == null || objectType == null) {
        return true;
    }
    return ((_accessMeta_objectType = accessMeta[objectType]) === null || _accessMeta_objectType === void 0 ? void 0 : _accessMeta_objectType[field.fieldIndex]) !== 0;
};
export const hasWriteAccessForField = (field, accessMeta)=>{
    var _accessMeta_accessMetaKey;
    if (accessMeta == null) {
        return false;
    }
    const { objectType, objectSubType } = field;
    if (field.fieldIndex == null || objectType == null) {
        return true;
    }
    const accessMetaKey = objectSubType !== FieldSectionSubType.Default && objectSubType || objectType;
    return ((_accessMeta_accessMetaKey = accessMeta[accessMetaKey]) === null || _accessMeta_accessMetaKey === void 0 ? void 0 : _accessMeta_accessMetaKey[field.fieldIndex]) === 2;
};
